import { createAction } from '../../utils/createAction';

import {
  ICountForNoteAction,
  ICountForProjectAction,
  IUpdateAllCountersAction,
  IUpdateCounterAction,
  STATS_COUNT_FOR_NOTE,
  STATS_COUNT_FOR_PROJECT,
  STATS_UPDATE_ALL_COUNTERS,
  STATS_UPDATE_COUNTER,
} from './stats.types';

export const countForNoteUpdateAct = createAction<ICountForNoteAction>(STATS_COUNT_FOR_NOTE);
export const countForProjectNotes = createAction<ICountForProjectAction>(STATS_COUNT_FOR_PROJECT);

export const updateCounter = createAction<IUpdateCounterAction>(STATS_UPDATE_COUNTER);
export const updateALLCounters = createAction<IUpdateAllCountersAction>(STATS_UPDATE_ALL_COUNTERS);
